import React, { useState, useEffect } from 'react';
import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import ConversationList from './ConversationList';
import Chat from './Chat';
import { startOfMonth, endOfMonth } from 'date-fns'; 


const Chats = () => {
  const now = new Date();
  const defaultStartOfMonth = startOfMonth(now);
  const defaultEndOfMonth = endOfMonth(now);

  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [dateStartRange, setDateStartRange] = useState(defaultStartOfMonth);
  const [dateEndRange, setDateEndRange] = useState(defaultEndOfMonth);

  useEffect(() => {
    const fetchConversations = async () => {
      const conversationsRef = collection(db, 'conversations');
      const q = query(
        conversationsRef,
        where('timestamp', '>=', dateStartRange),
        where('timestamp', '<=', dateEndRange),
        orderBy('timestamp', 'desc')
      );
      const querySnapshot = await getDocs(q);
      const chatData = [];
      querySnapshot.forEach((doc) => {
        chatData.push({ id: doc.id, ...doc.data() });
      });

      setConversations(chatData);

      if (chatData.length > 0) {
        setSelectedConversation(chatData[0]);
      }
    };

    fetchConversations();
  }, [dateStartRange, dateEndRange]);


  const handleSelectConversation = (conversation) => {
    setSelectedConversation(conversation);
  };

  return (
    <div className="flex h-screen bg-gray-20">
      {/* Sidebar: Fixed to the left and scrollable */}
      <div className="sticky top-0 w-64 h-screen bg-gray-100 p-4 border-r overflow-y-auto"> 
        <ConversationList
          conversations={conversations}
          setConversations={setConversations}
          onSelectConversation={handleSelectConversation}
          selectedConversation={selectedConversation}
          setStartDate={setDateStartRange}
          setEndDate={setDateEndRange}
          startDate={dateStartRange}
          endDate={dateEndRange}
        />
      </div>

      {/* Main Area */}
      <div className="flex-grow flex flex-col">
        {/* Chat Section */}
        <div className="flex-grow flex justify-center items-center p-6">
          <div className="w-full max-w-4xl h-full mt-20 flex flex-col items-center">
            <Chat selectedConversation={selectedConversation} />  {/* Still using the selectedConversation here */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chats;
